/* eslint-disable sort-imports */
import $ from 'jquery';
import ko from 'knockout';
import Profile from './viewmodels/profile';

const customerData = {
    findQuestionByName: function(name, data) {
        return data.Content.find(function(question) {
            return question.Question.QuestionName === name;
        });
    },
    getQuestionsByNames: function(data, names) {
        return names.map(
            function(name) {
                return this.findQuestionByName(name, data);
            }.bind(this)
        );
    },
    format: function(data) {
        var questions = [];

        data.Answers.forEach(
            function(answer) {
                if (answer.NextQuestion) {
                    questions.push(answer.NextQuestion);
                    questions = questions.concat(this.format(answer.NextQuestion));
                }
            }.bind(this)
        );

        return questions;
    },
    getQuestionsGroups: function(specificQuestions) {
        return specificQuestions.map(
            function(question) {
                return [question.Question].concat(this.format(question.Question, question.Question.QuestionId));
            }.bind(this)
        );
    },
    _getProfile: function(questionGroups, accountId){
        return new Profile(questionGroups, accountId);
    },
    init: function(obj, names) {
        var specificQuestions = this.getQuestionsByNames(obj, names),
            questionGroups = this.getQuestionsGroups(specificQuestions);

        ko.applyBindings(
            this._getProfile(questionGroups, obj.Content[0].AccountId),
            $('#customer').get(0)
        );
    }
};

export default customerData;

